import { useState } from 'react';
import { CmmConfig } from '../../../types/sharedTypeImpl.ts';
import { trpc, trpcClient } from '../../../utils/trpc/trpc.ts';
import { CmmConfigDialog } from './cmmConfigDialog.tsx';
import { CmmConfigsTable } from './cmmConfigsTable.tsx';

interface DialogState {
    isOpen: boolean,
    cmmConfig?: CmmConfig,
}


export function CmmConfigs() {
    const [dialogState, setDialogState] = useState<DialogState | null>(null);

    const { data: cmmConfigs, isLoading, error, refetch } = trpc.cmmConfigs.get.useQuery({ sort: { order: 1 } });



    const handleIsActiveChange = async (cmmConfig: CmmConfig, isActive: boolean) => {
        const newCmmConfig = { ...cmmConfig, isActive };
        await trpcClient.cmmConfigs.replace.mutate(newCmmConfig);
        refetch();
    };

    const handleOrderChange = async (cmmConfig: CmmConfig, direction: 'up' | 'down') => {
        if (!cmmConfigs) return;

        const index = cmmConfigs.findIndex(it => it._id === cmmConfig._id);
        if (index === -1) return;

        const swapIndex = direction === 'up' ? index - 1 : index + 1;
        if (swapIndex < 0 || swapIndex >= cmmConfigs.length) return;

        const itemA = cmmConfigs[index];
        const itemB = cmmConfigs[swapIndex];

        await trpcClient.cmmConfigs.replaceMany.mutate([
            { ...itemA, order: swapIndex },
            { ...itemB, order: index }
        ]);

        refetch();
    };


    return (<>
        <div>
            <h2>CMM configs</h2>
            <button
                onClick={() => setDialogState({ isOpen: true })}
                children='Add config'
            />
            {isLoading && <div>Loading...</div>}
            {error && <div>Error retrieving data</div>}
            {(cmmConfigs) &&
                <CmmConfigsTable
                    style={{ width: '800px' }}
                    cmmConfigs={cmmConfigs}
                    onEditClick={cmmConfig => setDialogState({ isOpen: true, cmmConfig })}
                    onIsActiveChange={handleIsActiveChange}
                    onOrderChange={handleOrderChange}
                />
            }
        </div>

        {(dialogState?.isOpen && cmmConfigs) &&
            <CmmConfigDialog
                cmmConfigUnderEdit={dialogState.cmmConfig}
                cmmConfigs={cmmConfigs}
                onCmmConfigSaved={() => refetch()}
                onClose={() => setDialogState(null)}
            />
        }
    </>)
}
